import { createContext, useContext } from 'react';
import type { PartyChatTab } from './PartyTabs';

/**
 * The party's Chat tab, provided once by the crucible page and read where
 * the party tabs show (the gathering, and the run's HUD), so a new message
 * re-renders only those tabs, not the pages around them. Null where there's
 * nobody to talk to.
 */
export const PartyChatContext = createContext<PartyChatTab | null>(null);

export function usePartyChatTab(): PartyChatTab | null {
    return useContext(PartyChatContext);
}
